import React, { useState } from "react";
import {
  Modal,
  ModalDialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Input,
  Typography,
} from "@mui/joy";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Put } from "../../services/apiServices";
import { networkUrls } from "../../services/networkurls";

interface EditModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  type: string;
  category?: string;
  name?: string;
  setIsShowSnackbar?: (val: boolean) => void | undefined;
  setSnackbarInfo?: (info: { message: string; color: string }) => void | undefined;
  id?: number | string | null;
  getCall?: () => void;
}

const EditPptModal: React.FC<EditModalProps> = ({
  open,
  setOpen,
  type,
  name = "",
  setIsShowSnackbar,
  setSnackbarInfo,
  id,
  getCall,
}) => {
    const [loading, setLoading] = useState (false);
  const formik = useFormik({
    initialValues: {
      fileName: name || "",
    },
    validationSchema: Yup.object({
      fileName: Yup.string().required("Name is required"),
    }),
    onSubmit: (values) => {
      handleEditFileName(values)
    },
  });
 const handleEditFileName = async (values:any) => {
    setLoading(true);
    const url = type === "transcript" ? networkUrls.updateTranscriptName : type==="video" ?  networkUrls.updateVideoName : networkUrls.updateDocument;
    try {
      const payload = {filename:values.fileName};

      const response: any = await Put(
        `${url}/${id}`,
        payload,
        true
      );
      if (response?.status === 200) {
        setSnackbarInfo?.({
          color: "success",
          message: response?.response?.message,
        });
        getCall?.();
        setOpen(false)
        setIsShowSnackbar?.(true);
      } else {
        setSnackbarInfo?.({
          color: "error",
          message: response?.response?.message,
        });
        setIsShowSnackbar?.(true);
      }
    } catch (error:any) {
      console.log(error,"error");
      setSnackbarInfo?.({
        color: "error",
        message: error?.message|| "An error occurred",
      });
      console.log(error, "error updating ppt name");
    }
    finally{
        setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)} >
      <ModalDialog sx={{width:400}}>
        <DialogTitle>Edit PPT Name</DialogTitle>
        <IconButton
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <DialogContent>
            <Typography level="body-sm">PPT Name</Typography>
            <Input
              name="fileName"
              value={formik.values.fileName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter File Name"
              error={formik.touched.fileName && Boolean(formik.errors.fileName)}
            />
            {formik.touched.fileName && formik.errors.fileName && (
              <Typography level="body-xs" color="danger" mt={0.5}>
                {formik.errors.fileName}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="solid" sx={{ backgroundColor: "#074c90" }} loading={loading}>
              Update
            </Button>
            <Button variant="outlined" color="neutral" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </DialogActions>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default EditPptModal;
